var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tw-font-bold tw-text-grey-700 tw-text-base tw-text-center tw-flex-shrink-0 tw-inline-flex tw-items-center"},[_c('CIcon',{attrs:{"icon":_vm.icons[_vm.icon],"size":"14"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }